import { useInjection } from '@mchs/web-core';
import MessengerService, { MESSENGER_SERVICE_TYPES } from './messengerService';

export function useMessengerService() {
  return useInjection<MessengerService>(MESSENGER_SERVICE_TYPES.MessengerService);
}
